import React, { memo, useEffect } from 'react';
import { Paper, Grid, Typography } from '@material-ui/core';
import theme from './style';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { BorderSelect } from '../../components/inputs';
import { CustomerVersionInvoices as Table } from '../../components/tables';
import { setInvoiceViewId } from '../../redux/actions/customer';
import { setInvoicesListFilter, fetchInvoicesList } from '../../redux/actions/customer/customerDetail';
import MockDataYears from '../../misc/mockDataYears';
import translate from '../../misc/applyTranslation'
import { useConfig } from "../../context/configContext";

import { withWidth } from '@material-ui/core';

const CustomerInvoiceList = (props) => {
  const config = useConfig();
  const classes = theme(config);
  const {
    setInvoiceViewId,
    setInvoicesListFilter,
    fetchInvoicesList,
    invoicesList,
    year,
    access_token,
    refresh_token,
    selectedCustomer,
  } = props;

  const handleTableSelect = (id) => {
    setInvoiceViewId(id);
  }

  useEffect(() => {
    fetchInvoicesList({
      customer_id: selectedCustomer,
      year: year,
      access_token: access_token,
      refresh_token: refresh_token,
    })
    // eslint-disable-next-line
  }, [year, selectedCustomer])


  return (
    <>
      <Paper elevation={4} className={classes.customerInvoiceListContainer}>
        <div className={classes.customerInvoiceListHeader} >
          <Typography className={'forceUppercase'}>{translate('invoices', 'invoices_userview_invoces_title')}</Typography>
          <Grid container style={{ width: '100%' }} spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <BorderSelect
                selected={year}
                onChange={(e) => setInvoicesListFilter(e)}
                items={MockDataYears}
              />
            </Grid>
          </Grid>
        </div>

        <div className={classes.customerInvoiceListContainerLaptop} style={{ width: 'calc(100% + 20px)' }}>
          <Table width={props.width} elevation={0} data={invoicesList} onClick={(id) => handleTableSelect(id)} />
        </div>

      </Paper >
      
        <div className={classes.customerInvoiceListContainerMobile}>
          <Table width={props.width} elevation={0} data={invoicesList} onClick={(id) => handleTableSelect(id)} />
        </div>
     

    </>
  );
}
CustomerInvoiceList.propTypes = {
  setInvoiceViewId: PropTypes.func.isRequired,
  invoicesList: PropTypes.array.isRequired,
  year: PropTypes.string.isRequired,
  access_token: PropTypes.string.isRequired,
  refresh_token: PropTypes.string.isRequired,
}
const mapStateToProps = store => ({
  invoicesList: store.customer.invoicesList.data,
  year: store.customer.invoicesListFilter.year,
  access_token: store.login.access_token,
  refresh_token: store.login.refresh_token,
  selectedCustomer: store.login.selectedCustomer,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators({
    setInvoiceViewId,
    setInvoicesListFilter,
    fetchInvoicesList
  }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(memo(withWidth()(CustomerInvoiceList)));